import { usePage } from "@inertiajs/react";

export const useCurrentAdminEmail = (): string | undefined => {
    return usePage<admin.IAdminPageProps>()?.props?.current_admin_email;
};
